<template>
     <Input
      container-class="me-2 mb-2 mb-md-0 h-35px"
      inputClass="form-control form-control-sm" 
      name="input-search"
      :isInputGroup="true"
      :placeholder="$t('label.search')"
      v-model="search"
    >
      <template #rightAddon>
        <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
          <i class="fa fa-search"></i>
        </span>
      </template>
    </Input>
    <DateRangePicker :id="id" @update:date="handleRangeDate" />
    <ButtonDropdownFilter
        btnClass=" h-35px"
        :btn-title="$t('expenses.label.allStatus')" 
        :search="false"
        :options="expenseStatus"
        value-field="value"
        :name-field="locale"
        v-model="status"
    />
    <ButtonDropdownFilter
        v-if="showOffice"
        btnClass=" h-35px"
        :options="[...offices]"
        value-field="id"
        name-field="name"
        v-model="office"

    />
    <ButtonDropdownFilter v-if="showType"
        btnClass=" h-35px"
        :btn-title="$t('expenses.label.allTypes')" 
        :search="false"
        :options="types"
        value-field="value"
        :name-field="locale"
        v-model="type"
    />
    <Button icon-class="fas fa-backspace" btn-class="btn-sm mb-2" type="cancel" btn-text="crm.back" @click="router.go(-1)"/>
</template>
<script setup>
import DateRangePicker from "@/components/DateRangePicker.vue";
import Input from "@/components/Input.vue";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import { useLocales } from "@/composables/locales";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import Button from "@/components/Button.vue";

const store = useStore()
const route = useRoute()
const router = useRouter()

const {locale} = useLocales()
const props = defineProps({
  id: {type: String, default: 'kt_td_picker_button'},
  showType: {type: Boolean, default: true},
  showOffice: {type: Boolean, default: true},
})

const start_date = defineModel('start_date')
const end_date = defineModel('end_date')
const search = defineModel('search')
const office = defineModel('office')
const status = defineModel('status')
const type = defineModel('type')

const offices = computed(() => store.getters['offices/getSocietyOffices'])
const expenseStatus = computed(() => store.getters['expenses/expenseStatus'])
const types = computed(() => store.getters['expenses/expenseTypes'])

function handleRangeDate (range) {
  start_date.value = range.start_date
  end_date.value = range.end_date
}


onMounted(() => {
  store.dispatch("offices/loadSocietyOffices", route.params.company)
  store.dispatch("expenses/loadExpenseStatus")
  store.dispatch("expenses/loadExpenseTypesEnum")
})
</script>
<style scoped>
</style>
  